import React from 'react';
import Bugsnag from '@bugsnag/js';
import {CHUNK_LOAD_RELOAD_KEY, isChunkLoadError} from '../../utility/chunkLoadRecovery';

const ErrorFallback = ({error}) => {
  const chunkLoadError = isChunkLoadError(error);

  React.useEffect(() => {
    if (!chunkLoadError) return;

    Bugsnag.leaveBreadcrumb('chunk-load-fallback-rendered');

    if (navigator.onLine === false) {
      Bugsnag.leaveBreadcrumb('chunk-load-reload-skipped', {reason: 'offline'});
      return;
    }

    try {
      if (window.sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY)) {
        Bugsnag.leaveBreadcrumb('chunk-load-reload-skipped', {
          reason: 'already-reloaded-this-session',
        });
        return;
      }
      window.sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, 'true');
    } catch (_) {
      // Without a persisted guard, an automatic reload could loop forever.
      Bugsnag.leaveBreadcrumb('chunk-load-reload-skipped', {
        reason: 'session-storage-unavailable',
      });
      return;
    }

    Bugsnag.leaveBreadcrumb('chunk-load-reload-attempted');
    window.location.reload();
  }, [chunkLoadError]);

  const message = chunkLoadError
    ? 'We could not load this page. Check your internet connection, then try again. If the issue continues, contact CoachFirst support.'
    : 'Please refresh this page and try again. If the issue continues, contact CoachFirst support.';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: '#fff',
        color: '#212529',
        textAlign: 'center',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      }}
    >
      <div style={{maxWidth: '520px'}}>
        <h1 style={{fontSize: '24px', marginBottom: '12px'}}>Something went wrong</h1>
        <p style={{fontSize: '16px', lineHeight: 1.5, marginBottom: '20px'}}>{message}</p>
        <button
          type="button"
          onClick={() => {
            if (chunkLoadError) {
              Bugsnag.leaveBreadcrumb('chunk-load-manual-retry');
              window.location.reload();
            } else {
              window.location.href = '/';
            }
          }}
          style={{
            border: 0,
            borderRadius: '4px',
            background: '#c72638',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '16px',
            padding: '10px 18px',
          }}
        >
          {chunkLoadError ? 'Try again' : 'Go to home page'}
        </button>
      </div>
    </div>
  );
};

export default ErrorFallback;
